// Language name if no match is found.
export const UNKNOWN_LANGUAGE = "Unknown Language";
